import React, { Component } from "react";
import {
  Table,
  Button,
  ButtonGroup,
  ButtonDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Badge,
  Input,
} from "reactstrap";
import { connect } from "react-redux";
import Select from "react-select";
import * as actions from "../../actions";
import { Container as DragContainer, Draggable } from "react-smooth-dnd";
import { PlaceVisit } from "./Components";
import { Spinner } from "react-activity";
import "react-activity/dist/react-activity.css";
import "./style.css";
import { DURATIONS, DAYS } from "../../constants/staticKeys";
import Popup from "reactjs-popup";

class ScheduleBuilder extends Component {
  componentDidMount() {
    this.props.getMasterPlans();
    this.props.getEfficiencyMatrix();
    this.props.getVenues("venuesLookup", 1, {
      page_size: 9999,
      filters: [{ filter_column: "efficiency_enabled", filter_value: "1" }],
    });
  }

  applyDrag = (arr, dragResult) => {
    const { removedIndex, addedIndex, payload } = dragResult;
    if (removedIndex === null && addedIndex === null) return arr;

    const result = [...arr];
    let itemToAdd = payload;

    if (removedIndex !== null) {
      itemToAdd = result.splice(removedIndex, 1)[0];
    }

    if (addedIndex !== null) {
      result.splice(addedIndex, 0, itemToAdd);
    }
    return result;
  };

  createNewPlan = (name) => {
    this.props.createNewPlan(name, this.props.scheduleBuilderReducer.plans);
  };

  addVisitToDay = (planIndex, day, visit) => {
    this.props.addVisitToDay(planIndex, day, visit);
  };

  removeVisitFromDay = (planIndex, day, visitIndex) => {
    this.props.removeVisitFromDay(planIndex, day, visitIndex);
  };

  computeSchedule = () => {
    this.props.computeSuggestions(this.props.scheduleBuilderReducer.plans);
  };

  saveScheduleBuilder = () => {
    const { plans, suggestedCombinations, isEfficiencyDirty } =
      this.props.scheduleBuilderReducer;
    this.props.saveScheduleBuilder(
      plans,
      suggestedCombinations,
      isEfficiencyDirty
    );
  };

  renderSuggestion = (
    day,
    duration,
    suggestedCombination,
    days,
    durations,
    isEfficiencyDirty
  ) => {
    let dayIndex = days.findIndex((val) => val === day);
    let durationIndex = durations.findIndex((val) => val === duration);
    let dayLetters = [];

    for (let i = 0; i < durationIndex + 1; i++) {
      let letter = days[dayIndex].substring(0, 1);
      dayIndex++;
      if (dayIndex >= 7) {
        dayIndex = 0;
      }
      dayLetters.push(letter);
    }

    const { venuesLookup, totalScore, isVenueLoading } = this.props.venuesReducer;
    const venueOptions = venuesLookup && venuesLookup.data ? venuesLookup.data : [];
    const { plans } = this.props.scheduleBuilderReducer;

    let option = null;
    let percentage = "";

    if (suggestedCombination.result === true) {
      option = suggestedCombination.bestOption.options[0];
      percentage = (
        (parseFloat(option.score).toFixed(2) * 100) /
        totalScore
      ).toFixed(0);
    }

    return (
      <div className="schedule-builder__suggestion">
        {suggestedCombination.isComputing ? (
          <div className="schedule-builder__suggestion-loading">
            <Spinner size={10} animating={true} color={"#c87244"} />
          </div>
        ) : suggestedCombination.result === true ? (
          <>
            <div className="schedule-builder__suggestion-state">
              {suggestedCombination.isSaving ? (
                <Badge
                  color={"info"}
                  className="schedule-builder__suggestion-badge"
                >
                  <Spinner size={5} animating={true} color={"#fff"} /> Saving
                </Badge>
              ) : null}
              {suggestedCombination.saved ? (
                <Badge
                  color={"success"}
                  className="schedule-builder__suggestion-badge"
                >
                  Saved
                </Badge>
              ) : null}
              {isEfficiencyDirty ? (
                <Badge
                  color={"warning"}
                  className="schedule-builder__suggestion-badge"
                >
                  Dirty
                </Badge>
              ) : null}
            </div>

            <table className="schedule-builder__suggestion-table">
              <tbody>
                <tr className="schedule-builder__suggestion-head">
                  {dayLetters.map((letter, index) => {
                    return (
                      <th key={`${duration}-${day}-${letter}-${index}`}>{letter.toUpperCase()}</th>
                    );
                  })}
                  <th>Cv</th>
                  <th>Eff</th>
                </tr>
                <tr>
                  {option.perm.map((planName, index) => {
                    let matchedPlan = plans.find((plan) => plan.name === planName);

                    if (matchedPlan === undefined) {
                      return <td key={`${planName}-${index}`}>!</td>;
                    }

                    return <td key={`${matchedPlan.name}-${index}`}>{matchedPlan.name}</td>;
                  })}
                  <td>{option.coverage}</td>
                  <td>
                    <Popup
                      trigger={
                        <span className="schedule-builder__suggestion-efficiency">
                          {percentage}%
                        </span>
                      }
                      position="top center"
                      on="hover"
                    >
                      <div className="schedule-builder__suggestion-popup">
                        <span className="schedule-builder__suggestion-popup-score">
                          {option.score} / {totalScore} - {percentage}%
                        </span>
                        {isVenueLoading ? (
                          <Spinner size={10} animating={true} color={"#c87244"} />
                        ) : (
                          venueOptions.map((place) => {
                            let isCovered = option.placesCovered.some(
                              (coveredPlace) => coveredPlace.name === place.name
                            );

                            return (
                              <div
                                className="schedule-builder__suggestion-popup-row"
                                key={`${duration}-${day}-${place.name}`}
                              >
                                <i
                                  className={
                                    isCovered
                                      ? "fa fa-check-circle"
                                      : "fa fa-times-circle"
                                  }
                                  style={{ color: isCovered ? "green" : "red" }}
                                />
                                <span>{place.name}</span>
                              </div>
                            );
                          })
                        )}
                      </div>
                    </Popup>
                  </td>
                </tr>
              </tbody>
            </table>
          </>
        ) : suggestedCombination.result === false ? (
          <p className="schedule-builder__suggestion-empty">Error</p>
        ) : (
          <p className="schedule-builder__suggestion-empty">Not Computed</p>
        )}
      </div>
    );
  };

  formatOptionLabel = (value, zoom) => {
    return (
      <DropdownItem className="schedule-builder__option-label">
        <span style={{ fontSize: zoom }}>{value.name}</span>
        <Badge color="info" style={{ fontSize: zoom, color: "white" }}>
          {value.score}
        </Badge>
      </DropdownItem>
    );
  };

  renderPlanMatrix = (plans, days, zoom, isVenueLoading, venueOptions) => {
    return plans.map((plan, planIndex) => {
      return (
        <tr key={plan.id || plan.name || planIndex}>
          <td>
            <div className="schedule-builder-plan-cell">
              <Input
                value={plan.name}
                onChange={(e) => {
                  this.props.updateScheduleBuilderProps([
                    {
                      prop: `plans.${planIndex}.name`,
                      value: e.target.value,
                    },
                  ]);
                }}
                style={{ minWidth: 80, fontSize: zoom }}
                type="text"
                placeholder="Plan name.."
                className="schedule-builder-plan-cell__input"
              />

              <Button
                color={"danger"}
                className="schedule-builder-plan-cell__delete"
                onClick={() => {
                  this.props.deletePlan(plan, planIndex);
                }}
              >
                {plan.isDeleteLoading ? (
                  <Spinner
                    size={10}
                    animating={plan.isDeleteLoading === true}
                    color={"white"}
                  />
                ) : (
                  <i
                    className="fa fa-trash"
                    style={{ fontSize: zoom, color: "white" }}
                  />
                )}
              </Button>

              {plan.hasOwnProperty("code") ? (
                <p className="schedule-builder-plan-cell__error">{plan.err}</p>
              ) : null}
            </div>
          </td>

          {days.map((day) => {
            return (
              <td key={day}>
                <Badge color="info" className="schedule-builder-day-score">
                  Score: {plan[day].score}
                </Badge>

                <DragContainer
                  groupName={"mainList"}
                  getChildPayload={(i) => plan[day].visits[i]}
                  onDrop={(e) =>
                    this.props.updateScheduleBuilderProps([
                      {
                        prop: `plans.${planIndex}.${day}.visits`,
                        value: this.applyDrag(plan[day].visits, e),
                      },
                      { prop: "isEfficiencyDirty", value: true },
                    ])
                  }
                  dropPlaceholder={{
                    animationDuration: 150,
                    showOnTop: true,
                    className: "drop-preview",
                  }}
                  className="schedule-builder-dropzone"
                >
                  {plan[day].visits.map((visit, index) => {
                    return (
                      <Draggable key={index}>
                        <PlaceVisit
                          visit={visit}
                          planIndex={planIndex}
                          day={day}
                          index={index}
                          deleteScheduleBuilderProps={
                            this.props.deleteScheduleBuilderProps
                          }
                          updateScheduleBuilderProps={
                            this.props.updateScheduleBuilderProps
                          }
                          removeVisitFromDay={this.removeVisitFromDay}
                        />
                      </Draggable>
                    );
                  })}

                  <ButtonDropdown
                    className="schedule-builder-add-visit"
                    isOpen={plan[day].isOpenDropdown}
                    toggle={() => {
                      this.props.updateScheduleBuilderProps([
                        {
                          prop: `plans.${planIndex}.${day}.isOpenDropdown`,
                          value: !plan[day].isOpenDropdown,
                        },
                      ]);
                    }}
                  >
                    <DropdownToggle
                      outline
                      color="success"
                      className="schedule-builder-add-visit__toggle"
                    >
                      <i className={"fa fa-plus"} />
                    </DropdownToggle>
                    <DropdownMenu className="schedule-builder-add-visit__menu">
                      {isVenueLoading ? (
                        <div className="schedule-builder-add-visit__loading">
                          <Spinner size={10} animating={true} color={"#c87244"} />
                        </div>
                      ) : (
                        <Select
                          className="schedule-builder-add-visit__select"
                          classNamePrefix="schedule-builder-select"
                          options={venueOptions}
                          getOptionLabel={(data) => {
                            return data.name;
                          }}
                          getOptionValue={(data) => {
                            return data.id;
                          }}
                          menuIsOpen={true}
                          onChange={(item) => {
                            this.addVisitToDay(
                              planIndex,
                              day,
                              JSON.parse(JSON.stringify(item))
                            );
                          }}
                          formatOptionLabel={(value) =>
                            this.formatOptionLabel(value, zoom)
                          }
                          autoFocus={true}
                        />
                      )}
                    </DropdownMenu>
                  </ButtonDropdown>
                </DragContainer>
              </td>
            );
          })}
        </tr>
      );
    });
  };

  render() {
    const {
      plans,
      suggestedCombinations,
      zoom,
      isEfficiencyMatrixLoading,
      isMasterPlanLoading,
      isMasterPlanSaveLoading,
      isEfficiencyDirty,
      isMatrixSaving,
    } = this.props.scheduleBuilderReducer;
    const { venuesLookup, isVenueLoading } = this.props.venuesReducer;
    const venueOptions = venuesLookup && venuesLookup.data ? venuesLookup.data : [];

    const hasSuggestions = Object.keys(suggestedCombinations).length > 0;
    const activeVenueCount = venueOptions.length;

    return (
      <div className="schedule-builder-page">
        <div className="schedule-builder-page__hero">
          <div>
            <div className="schedule-builder-page__eyebrow">Planning Workspace</div>
            <h1 className="schedule-builder-page__title">Smart Schedule Builder</h1>
            <p className="schedule-builder-page__copy">
              Build weekly visit plans, tune daily coverage, and compute efficient
              combinations from one focused operations board.
            </p>
          </div>

          <div className="schedule-builder-page__stats">
            <div className="schedule-builder-stat">
              <span className="schedule-builder-stat__value">{plans.length}</span>
              <span className="schedule-builder-stat__label">Plans</span>
            </div>
            <div className="schedule-builder-stat">
              <span className="schedule-builder-stat__value">{activeVenueCount}</span>
              <span className="schedule-builder-stat__label">Active venues</span>
            </div>
            <div className="schedule-builder-stat">
              <span className="schedule-builder-stat__value">
                {hasSuggestions ? "Ready" : "Idle"}
              </span>
              <span className="schedule-builder-stat__label">Efficiency state</span>
            </div>
          </div>
        </div>

        <div className="schedule-builder-toolbar">
          <div className="schedule-builder-toolbar__actions">
            <ButtonGroup className="schedule-builder-toolbar__group">
              <Button
                color={"faiz1"}
                className="schedule-builder-toolbar__button"
                onClick={() => {
                  this.createNewPlan("");
                }}
              >
                <i className="fa fa-plus" style={{ color: "white" }} /> New Plan
              </Button>
              <Button
                disabled={plans.length === 0}
                color={"faiz2"}
                className="schedule-builder-toolbar__button"
                onClick={() => this.computeSchedule()}
              >
                {isMasterPlanSaveLoading ? (
                  <Spinner size={10} animating={true} color={"#fff"} />
                ) : null}
                <i className="fa fa-calculator" style={{ color: "white" }} /> Compute
                Efficiency
              </Button>
              <Button
                disabled={plans.length === 0}
                color={"faiz3"}
                className="schedule-builder-toolbar__button"
                onClick={() => {
                  this.saveScheduleBuilder();
                }}
              >
                {isMatrixSaving ? (
                  <Spinner size={10} animating={true} color={"#fff"} />
                ) : null}
                <i className="fa fa-floppy-o" style={{ color: "white" }} /> Save
                Efficiency
              </Button>
            </ButtonGroup>
          </div>

          <div className="schedule-builder-toolbar__meta">
            {isEfficiencyDirty ? (
              <Badge color="warning" className="schedule-builder-toolbar__badge">
                Unsaved efficiency changes
              </Badge>
            ) : null}

            <div className="schedule-builder-zoom">
              <ButtonGroup className="schedule-builder-toolbar__group">
                <Button
                  color={"faiz1"}
                  className="schedule-builder-toolbar__button"
                  onClick={() => {
                    this.props.updateScheduleBuilderProps([
                      { prop: "zoom", value: zoom - 1 },
                    ]);
                  }}
                >
                  <i className="fa fa-search-minus" style={{ color: "white" }} />
                </Button>
                <div className="schedule-builder-zoom__value">
                  <span>{zoom}</span>
                </div>
                <Button
                  color={"faiz1"}
                  className="schedule-builder-toolbar__button"
                  onClick={() => {
                    this.props.updateScheduleBuilderProps([
                      { prop: "zoom", value: zoom + 1 },
                    ]);
                  }}
                >
                  <i className="fa fa-search-plus" style={{ color: "white" }} />
                </Button>
              </ButtonGroup>
            </div>
          </div>
        </div>

        <section className="schedule-builder-card">
          <div className="schedule-builder-card__header">
            <div>
              <div className="schedule-builder-card__eyebrow">Step 1</div>
              <h2 className="schedule-builder-card__title">Weekly Plan Matrix</h2>
              <p className="schedule-builder-card__copy">
                Create and name plans, add venues to each day, then reorder visits by drag
                and drop.
              </p>
            </div>
          </div>

          <div className="schedule-builder-table-shell" style={{ fontSize: zoom }}>
            <Table responsive bordered className="schedule-builder-table">
              <thead>
                <tr>
                  <th>
                    <div className="schedule-builder-table__heading">
                      <b>Plan</b>
                    </div>
                  </th>
                  {DAYS.map((day) => {
                    return (
                      <th key={day}>
                        <div className="schedule-builder-table__heading">
                          <b>{day.charAt(0).toUpperCase() + day.slice(1)}</b>
                        </div>
                      </th>
                    );
                  })}
                </tr>
              </thead>

              <tbody>
                {isMasterPlanLoading ? (
                  <tr>
                    <td colSpan={8}>
                      <div className="schedule-builder-state">
                        <Spinner size={10} animating={true} color={"#c87244"} />
                      </div>
                    </td>
                  </tr>
                ) : plans.length === 0 ? (
                  <tr>
                    <td colSpan={8}>
                      <div className="schedule-builder-state">
                        <img
                          src={"assets/img/analysis.png"}
                          className="schedule-builder-state__art"
                          alt="Analysis illustration"
                        />
                        <span className="schedule-builder-state__title">No plans found</span>
                      </div>
                      <div className="schedule-builder-state__action">
                        <Button
                          color={"faiz1"}
                          onClick={() => {
                            this.createNewPlan("");
                          }}
                        >
                          Make a Plan
                        </Button>
                      </div>
                    </td>
                  </tr>
                ) : (
                  this.renderPlanMatrix(plans, DAYS, zoom, isVenueLoading, venueOptions)
                )}
              </tbody>
            </Table>
          </div>
        </section>

        <section className="schedule-builder-card schedule-builder-card--analysis">
          <div className="schedule-builder-card__header">
            <div>
              <div className="schedule-builder-card__eyebrow">Step 2</div>
              <h2 className="schedule-builder-card__title">Efficiency Matrix</h2>
              <p className="schedule-builder-card__copy">
                Review the strongest plan combinations by duration and weekday start.
              </p>
            </div>
          </div>

          <div className="schedule-builder-table-shell">
            <Table responsive bordered className="schedule-builder-table">
              <tbody>
                <tr>
                  <td>
                    <div className="schedule-builder-table__heading">
                      <b>Duration of Stay</b>
                    </div>
                  </td>
                  {DAYS.map((day) => {
                    return (
                      <td key={day}>
                        <div className="schedule-builder-table__heading">
                          <b>{day.charAt(0).toUpperCase() + day.slice(1)}</b>
                        </div>
                      </td>
                    );
                  })}
                </tr>

                {!hasSuggestions && !isEfficiencyMatrixLoading ? (
                  <tr>
                    <td colSpan={8}>
                      <div className="schedule-builder-state">
                        <img
                          src={"assets/img/efficiencyBroken.png"}
                          className="schedule-builder-state__art"
                          alt="Efficiency placeholder"
                        />
                        <span className="schedule-builder-state__title">
                          No efficiency computed
                        </span>
                      </div>
                    </td>
                  </tr>
                ) : isEfficiencyMatrixLoading ? (
                  <tr>
                    <td colSpan={8}>
                      <div className="schedule-builder-state">
                        <Spinner size={10} animating={true} color={"#c87244"} />
                      </div>
                    </td>
                  </tr>
                ) : (
                  DURATIONS.map((duration) => {
                    return (
                      <tr key={duration}>
                        <td style={{ verticalAlign: "middle" }}>
                          <div className="schedule-builder-duration">
                            <b>{duration}</b>
                          </div>
                        </td>
                        {DAYS.map((day) => {
                          return suggestedCombinations === undefined ||
                            suggestedCombinations[duration] === undefined ||
                            suggestedCombinations[duration][day] === undefined ? null : (
                            <td key={`${duration}-${day}`}>
                              {this.renderSuggestion(
                                day,
                                duration,
                                suggestedCombinations[duration][day],
                                DAYS,
                                DURATIONS,
                                isEfficiencyDirty
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = ({ scheduleBuilderReducer, venuesReducer }) => ({
  scheduleBuilderReducer,
  venuesReducer,
});

export default connect(mapStateToProps, actions)(ScheduleBuilder);
